<template>
  <!-- 面包屑 -->
  <div class="layout-breadcrumb" v-if="!hideBreadcrumb">
    <Breadcrumb>
      <BreadcrumbItem v-for="item in BreadMenuData"
        :to="item.path ? item.path.includes('/details') ? null: item.path : null">
        {{ item.name }}
      </BreadcrumbItem>
    </Breadcrumb>
    <div class="flex align-items-center">
      <span class="cursor themeColor ml10 mr10 font-size-13" v-for="item in operatingInstructionsList" @click="previewGuideBtn(item)">
        {{ item.title }}
      </span>
    </div>
  </div>

</template>

<script>
import Mixin from '@/components/mixin/common_mixin';
import ymsMenu from '@/config/menu/yms';
import supplierMenu from "@/config/menu/supplier";
import distributorMenu from "@/config/menu/distributor";
import api from "@/api";
import {getHrefPath} from "@/utils/common";

export default {
  name: 'breadcrumb',
  mixins: [Mixin],
  data() {
    return {
      BreadMenuData: [],
      BreadMenuAllData: [],
      menuData: [],
      hideBreadcrumb: false,
      operatingInstructionsList: [],
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.setMenuData();
      this.setBreadMenuData();
      this.getBreadMenuData();
    },
    setMenuData() {
      let pathname = window.location.pathname;
      let pathnameList = [
        {pathname: '/yms.html', menu: JSON.parse(JSON.stringify(ymsMenu))},
        {pathname: '/supplier.html', menu: JSON.parse(JSON.stringify(supplierMenu))},
        {pathname: '/distributor.html', menu: JSON.parse(JSON.stringify(distributorMenu))},
      ];
      pathnameList.map((item) => {
        if (pathname.includes(item.pathname)) {
          this.menuData = item.menu;
        }
      });
    },
    // 设置面包屑
    setBreadMenuData() {
      if (!this.menuData?.menu) return [];
      const walk = (list, breadMenu = [], breadIndex = 0) => {
        list.forEach(item => {
          const currentBread = {
            name: item.name,
            path: item.path || null,
            hideCrumbs: !!item.hideCrumbs
          };
          item.breadMenu = [...breadMenu];
          item.breadMenu[breadIndex] = currentBread;
          item.breadIndex = breadIndex;
          const children = item.children || [];
          // 子菜单全部隐藏，也算叶子节点
          if (children.length === 0 || children.every(c => c.menuHide)) {
            this.BreadMenuAllData.push(item);
            return;
          }
          walk(children, item.breadMenu, breadIndex + 1);
        });
      };
      walk(this.menuData.menu);
    },
    getBreadMenuData() {
      this.BreadMenuData = [];
      if (this.BreadMenuAllData) {
        this.BreadMenuAllData.map(i => {
          if (i.path === this.$route.path) {
            if (i.breadMenu) {
              this.BreadMenuData = i.breadMenu;
            }
          }
        });
      }
    },
    // 获取对应系统的操作指引数据
    getSystemOperationGuidelinesData() {
      let v = this;
      let arr = v.$store.state.helpGuide || [];
      arr.forEach(i => {
        let obj = i.docsInternationalQueryResultList.find(obj => obj.language === v.languagesVal);
        if (obj) {
          i.title = obj.title;
        }
      });
      v.operatingInstructionsList = arr.slice(0, 3);
    },
    // 预览指引内容
    previewGuideBtn(item) {
      let v = this;
      const {href} = v.$router.resolve({
        path: '/viewGuideContent',
        query: {
          docsId: item.docsId,
        }
      });
      window.open(href, '_blank');
    }
  },
  watch: {
    '$route': {
      handler: 'getBreadMenuData',
      deep: true
    },
    BreadMenuData: {
      handler(data) {
        this.hideBreadcrumb = false;
        if (data && data.length > 0) {
          this.getSystemOperationGuidelinesData();
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            if (item.hideCrumbs) {
              this.hideBreadcrumb = true;
              return false;
            }
          }
        } else {
          this.hideBreadcrumb = true;
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>

.layout-breadcrumb {
  background-color: #fff;
  font-size: 15px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
